import { render, staticRenderFns } from "./AddHoldTicketPage.vue?vue&type=template&id=519a17d7&scoped=true&"
import script from "./AddHoldTicketPage.vue?vue&type=script&lang=ts&"
export * from "./AddHoldTicketPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddHoldTicketPage.vue?vue&type=style&index=0&id=519a17d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a17d7",
  null
  
)

export default component.exports